export const MaxRules = 1000;
export const MinRules = 500;

export const MinDescriptionRules = 200;

export const TeamMinRules = 200;
export const TeamMaxRules = 1000;
/**
 * 范围选项修改（不能影响之前提交信息的账号应用）
 * - 单选 {{1-100}}  {{101-1000}}  {{1001-10000}}
 * {{10001-50000}}  {{50001-100000}}  {{More than 100000}}
 * https://www.notion.so/dser/Dev-Super-Dev-Super-73670fb090544ed1ae50368c16c9bf99
 */
export const UserScaleType = [
  {
    id: 1,
    label: '0~100',
    value: 'USER_SIZE_0_100',
  },
  {
    id: 2,
    label: '101~1000',
    value: 'USER_SIZE_101_1000',
  },
  {
    id: 3,
    label: '1001~10000',
    value: 'USER_SIZE_1001_10000',
  },
  {
    id: 4,
    label: '10001~50000',
    value: 'USER_SIZE_10001_50000',
  },
  {
    id: 5,
    label: '50001~100000',
    value: 'USER_SIZE_50001_100000',
  },
  {
    id: 6,
    label: 'More than 100000',
    value: 'USER_SIZE_GREATER_THAN_100001',
  },
  // {
  //   id: 2,
  //   label: '101~500',
  //   value: 'USER_SIZE_101_500',
  // },
  // {
  //   id: 3,
  //   label: '501~1000',
  //   value: 'USER_SIZE_501_1000',
  // },
  // {
  //   id: 4,
  //   label: '1001~5000',
  //   value: 'USER_SIZE_1001_5000',
  // },
  // {
  //   id: 5,
  //   label: '5001+',
  //   value: 'USER_SIZE_GREATER_THAN_5001',
  // },
];
